import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerificationPackagesTableMessageService {

  @Output() applyFilterEvent = new EventEmitter();

  applyFilter(): void {
    this.applyFilterEvent.emit();
  }
}